import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadContractRevenueValuesListStatus: 'idle',
    loadContractRevenueValuesListError: undefined as any,
    loadContractRevenueValuesListLastArgs: undefined as any,
    loadContractRevenueValueStatus: 'idle',
    loadContractRevenueValueError: undefined as any,
    saveContractRevenueValueStatus: 'idle',
    saveContractRevenueValueError: undefined as any,
    deleteContractRevenueValueStatus: 'idle',
    deleteContractRevenueValueError: undefined as any,

    flubeList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadContractRevenueValuesList = createAsyncThunk('flubeSlice/loadContractRevenueValuesList', async ({ year, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().flubeSlice.loadContractRevenueValuesListLastArgs
    if (_.isEqual(lastArgs, { year }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/FlubeYearList/$year/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { year }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRevenueValuesListStatus } = getState().flubeSlice
        return loadContractRevenueValuesListStatus !== 'pending'
    }
})

export const loadContractRevenueValue = createAsyncThunk('flubeSlice/loadContractRevenueValue', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/flube/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadContractRevenueValueStatus } = getState().flubeSlice
        return loadContractRevenueValueStatus !== 'pending'
    }
})

export const saveContractRevenueValue = createAsyncThunk('flubeSlice/saveContractRevenueValue', async ({ flube }: any, { rejectWithValue }: any) => {
    let promises = []
    if (flube?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/flube/${ flube?.HDR_ID }/`,
            prepareData(flube),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/flube/`,
            prepareData(flube),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveContractRevenueValueStatus } = getState().flubeSlice
        return saveContractRevenueValueStatus !== 'pending'
    }
})

export const deleteContractRevenueValue = createAsyncThunk('flubeSlice/deleteContractRevenueValue', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/flube/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteContractRevenueValueStatus } = getState().flubeSlice
        return deleteContractRevenueValueStatus !== 'pending'
    }
})

const FlubeSlice = createSlice({
    name: 'flubeSlice',
    initialState,
    reducers: {
        resetloadContractRevenueValuesListError: (state) => {
            state.loadContractRevenueValuesListError = undefined
        },
        resetloadContractRevenueValue: (state) => {
            state.formItem = undefined
            state.loadContractRevenueValueError = undefined
        },
        resetloadContractRevenueValueError: (state) => {
            state.loadContractRevenueValueError = undefined
        },
        resetsaveContractRevenueValue: (state) => {
            state.formItem = undefined
            state.saveContractRevenueValueError = undefined
        },
        resetsaveContractRevenueValueError: (state) => {
            state.saveContractRevenueValueError = undefined
        },
        resetdeleteContractRevenueValueError: (state) => {
            state.deleteContractRevenueValueError = undefined
        },
        removeFromFlubeListById: (state, action) => {
            state.flubeList = state.flubeList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromFlubeListByIds: (state, action) => {
            state.flubeList = state.flubeList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.flubeList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadContractRevenueValuesListStatus = 'preloaded'
            state.loadContractRevenueValuesListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.flubeList = []
            state.loadContractRevenueValuesListStatus = 'idle'
            state.loadContractRevenueValuesListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadContractRevenueValuesList.pending, (state) => {
            state.loadContractRevenueValuesListStatus = 'pending'
            state.loadContractRevenueValuesListError = undefined
        })
        builder.addCase(loadContractRevenueValuesList.fulfilled, (state, action) => {
            state.loadContractRevenueValuesListStatus = 'idle'

            if (!action.payload) { return }

            state.loadContractRevenueValuesListLastArgs = action.payload.args

            {
                state.flubeList = action.payload.data

            }
        })
        builder.addCase(loadContractRevenueValuesList.rejected, (state, action) => {
            state.loadContractRevenueValuesListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRevenueValuesListError = action.error.message
            } else {
                state.loadContractRevenueValuesListError = action.payload
            }
        })

        builder.addCase(loadContractRevenueValue.pending, (state) => {
            state.loadContractRevenueValueStatus = 'pending'
            state.loadContractRevenueValueError = undefined
        })
        builder.addCase(loadContractRevenueValue.fulfilled, (state, action) => {
            state.loadContractRevenueValueStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flubeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flubeList.push(newItem) }
                else { state.flubeList[i] = { ...state.flubeList[i], ...newItem } }
            }
        })
        builder.addCase(loadContractRevenueValue.rejected, (state, action) => {
            state.loadContractRevenueValueStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadContractRevenueValueError = action.error.message
            } else {
                state.loadContractRevenueValueError = action.payload
            }
        })

        builder.addCase(saveContractRevenueValue.pending, (state) => {
            state.saveContractRevenueValueStatus = 'pending'
            state.saveContractRevenueValueError = undefined
        })
        builder.addCase(saveContractRevenueValue.fulfilled, (state, action) => {
            state.saveContractRevenueValueStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.flubeList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.flubeList.push(newItem) }
                else { state.flubeList[i] = { ...state.flubeList[i], ...newItem } }
            }
        })
        builder.addCase(saveContractRevenueValue.rejected, (state, action) => {
            state.saveContractRevenueValueStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveContractRevenueValueError = action.error.message
            } else {
                state.saveContractRevenueValueError = action.payload
            }
        })

        builder.addCase(deleteContractRevenueValue.pending, (state) => {
            state.deleteContractRevenueValueStatus = 'pending'
            state.deleteContractRevenueValueError = undefined
        })
        builder.addCase(deleteContractRevenueValue.fulfilled, (state, action) => {
            state.deleteContractRevenueValueStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.flubeList = state.flubeList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.flubeList = state.flubeList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteContractRevenueValue.rejected, (state, action) => {
            state.deleteContractRevenueValueStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteContractRevenueValueError = action.error.message
            } else {
                state.deleteContractRevenueValueError = action.payload
            }
        })

    }
})

export const {
    resetloadContractRevenueValuesListError,
    resetloadContractRevenueValue,
    resetloadContractRevenueValueError,
    resetsaveContractRevenueValue,
    resetsaveContractRevenueValueError,
    resetdeleteContractRevenueValueError,
    removeFromFlubeListById,
    removeFromFlubeListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = FlubeSlice.actions
export default FlubeSlice.reducer
